import eventBus from '@sas/nova-core/eventBus';
import { appReadyEvent } from '@sas/nova-core/eventBus/appEventTypes';
import { useEffect } from 'react';

/**
 * This is used to help the non-React splash screen be removed and to be used in conjunction with the AppRoot level Suspense.
 */

export const AppReadyHelper = () => {
  useEffect(() => {
    return () => {
      eventBus.publish(appReadyEvent);
    };
  }, []);
  return null;
};

/**
 * When used as the last child component of a Suspense, will issue an appReadyEvent.
 *
 * If all the siblings preceeding it can render without throwing a Suspense then we can safely assume the Suspense
 * will resolve. This can be used to catch timing situations where the Suspense's fallback isn't rendered.
 */
export const SiblingAppReadyHelper = () => {
  useEffect(() => {
    eventBus.publish(appReadyEvent);
  }, []);
  return null;
};
